// extracted by mini-css-extract-plugin
module.exports = {"adLogo":"_2vHmin"};